export const COVER_IMAGE_RATIO = 1 / 1;
export const NATURE_SOUND_COVER_IMAGE_RATIO = 1 / 1;
export const BACKGROUND_IMAGE_RATIO = 375 / 734;
export const ICON_IMAGE_RATIO = 1 / 1;

class ApplicationSettings {
    readonly baseUrl = location.origin;
    readonly filesHostUrl = "https://dois.affiro.app";
    private static instance: ApplicationSettings;
    private constructor() {
    }

    readonly adminApiHostUrl = "https://dois.affiro.app";
    readonly socketHostUrl = "dois.affiro.app";

    /** Is localhost */
    get localhost(): boolean {
        return location.host.indexOf('localhost') > -1;
    }

    get isHttpOrigin(): boolean {
        return location.protocol === 'http:' || location.protocol === 'https:';
    }

    get socketUrl(): string {
        if (this.isHttpOrigin) {
            if (this.localhost) {
                const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
                return `${protocol}//${location.host}/websocket`;
            }

            const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
            return `${protocol}//${location.host}/websocket`;
        }

        return `wss://${this.socketHostUrl}/websocket`;
    };

    get adminApiUrl(): string {
        if (this.isHttpOrigin) {
            return this.baseUrl;
        }

        return this.adminApiHostUrl;
    };

    get filesBaseUrl(): string {
        if (this.localhost) {
            return this.filesHostUrl;
        }

        return this.baseUrl;
    };

    static getInstance(): ApplicationSettings {
        if (!ApplicationSettings.instance) {
            ApplicationSettings.instance = new ApplicationSettings();
        }
        return ApplicationSettings.instance;
    }
}

var settings = ApplicationSettings.getInstance();
export default settings;
